export class Filter {
  constructor(public type: FilterType,
              public active: boolean,
              public value: FilterValue) {} 
}

export enum FilterType {
  CATEGORY = 'CATEGORY',
  SEARCH = 'SEARCH',
  PRICE = 'PRICE',
  GEO = 'GEO',
  TAG = 'TAG'
}

export interface GeoFilter {
  radius: number,
  latitude: number,
  longitude: number
}

export interface PriceFilter {
  minPrice: number,
  maxPrice: number
}

export type FilterValue = GeoFilter | PriceFilter | string | number;



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/models/Filter.ts